import { StyleProp, ViewStyle } from 'react-native';
import { Theme } from '_utils';
import icons from './IconFiles';

export interface IconProps {
    color: keyof Theme;
    name: keyof typeof icons;
    style?: StyleProp<ViewStyle>;
    scale?: number;
}

export const StrokeIcons = ['car'];
